// import { Link } from "react-router-dom";
// import { Twitter, Instagram, Linkedin, Youtube, ChevronRight } from "lucide-react";
// import logo from "../images/ctv_logo.png";
// import HeroBg from "../images/hero-bg.png";

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   return (
//     <footer className="relative w-full overflow-hidden">

//       <div className="absolute inset-0">
//         <img
//           src={HeroBg}
//           alt="bg"
//           className="w-full h-full object-cover rotate-180 opacity-50"
//         />
//       </div>

//       <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-indigo-200 via-purple-200 to-indigo-200" />

//       {/* ===== Content ===== */}
//       <div className="relative z-10 px-6 py-8">
//         <div className="max-w-6xl mx-auto">

//           <div className="flex flex-col lg:flex-row justify-between gap-12">
//             {/* LEFT */}
//             <div className="lg:w-1/3">
//               <div className="flex items-center gap-3 mb-5">
//                 <img src={logo} className="h-11 w-11 rounded-lg rotate-180" alt="logo" />
//                 <span className="text-xl font-semibold text-gray-900 mb-2">SocialTV</span>
//               </div>

//               <p className="text-gray-600 text-sm leading-relaxed mb-6 max-w-sm">
//                 Transform your social media posts into stunning 4K TV ads.
//                 The simplest way to reach audiences on connected TV.
//               </p>

//               {/* Social */}
//               {/* <div className="flex gap-3">
//                 {[
//                   { Icon: Twitter, hover: "hover:bg-sky-500" },
//                   { Icon: Instagram, hover: "hover:bg-gradient-to-r hover:from-pink-500 hover:to-purple-500" },
//                   { Icon: Linkedin, hover: "hover:bg-blue-600" },
//                   { Icon: Youtube, hover: "hover:bg-red-600" },
//                 ].map(({ Icon, hover }, i) => (
//                   <button
//                     key={i}
//                     className={`w-10 h-10 rounded-xl bg-white/70 backdrop-blur-md border border-white/40 
//                   flex items-center justify-center text-gray-600
//                   ${hover} hover:text-white hover:scale-110
//                   transition-all duration-300 shadow-sm`}
//                   >
//                     <Icon size={16} />
//                   </button>
//                 ))}
//               </div> */}


//               <div className="flex gap-3">
//                 {[
//                   { Icon: Twitter, name: "Twitter", bg: "bg-[#1DA1F2]/10", hover: "hover:bg-[#1DA1F2]", iconColor: "text-[#1DA1F2]", link: "https://x.com/jambojar" },
//                   { Icon: Linkedin, name: "LinkedIn", bg: "bg-[#0A66C2]/10", hover: "hover:bg-[#0A66C2]", iconColor: "text-[#0A66C2]", link: "https://www.linkedin.com/company/jambojar/about/" },
//                   { Icon: Youtube, name: "YouTube", bg: "bg-red-500/10", hover: "hover:bg-[#FF0000]", iconColor: "text-red-500", link: "https://www.linkedin.com/company/jambojar/about/" },
//                 ].map(({ Icon, name, bg, hover, iconColor, link }, i) => (
//                   <a
//                     key={i}
//                     href={link}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className={`w-10 h-10 rounded-full ${bg} backdrop-blur-sm flex items-center justify-center transition-all duration-300 
//                   hover:scale-110 hover:shadow-lg ${hover} group`}
//                   >
//                     <Icon size="16" className={`${iconColor} group-hover:text-white transition-colors`} />
//                   </a>
//                 ))}
//               </div>

//             </div>

//             {/* RIGHT */}
//             <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-3 gap-10">
//               {[
//                 { title: "Company", links: [{ name: "Home", path: "/" }, { name: "About Us", path: "/about" }] },
//                 { title: "Resources", links: [{ name: "Support", path: "/support" }, { name: "Contact Us", path: "/contact" }] },
//                 { title: "Legal", links: [{ name: "Privacy Policy", path: "/privacy" }, { name: "Terms", path: "/terms" }] },
//               ].map((section, idx) => (
//                 <div key={idx}>
//                   <h4 className="text-xs font-semibold text-gray-600 uppercase tracking-wider mb-4">
//                     {section.title}
//                   </h4>

//                   <ul className="space-y-3">
//                     {section.links.map((link, i) => (
//                       <li key={i}>
//                         <Link
//                           to={link.path}
//                           // className="group flex items-center gap-2 text-gray-600 text-sm hover:text-purple-600 transition-all duration-300"
//                           className="group flex items-center gap-2 text-gray-600 text-sm hover:text-[#ff6968] transition-all duration-300"

//                         >
//                           {/* <ChevronRight
//                             size={14}
//                             className="text-purple-500 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
//                           /> */}
//                           <span className="group-hover:translate-x-1 transition-all duration-300">
//                             {link.name}
//                           </span>
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Bottom */}
//           <div className="h-px w-full bg-gradient-to-r from-indigo-200 via-purple-200 to-indigo-200 my-6" />

//           <p className="text-gray-600 text-sm text-center">
//             © {currentYear} SocialTV. All rights reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import { Link } from "react-router-dom";
import { Twitter, Instagram, Linkedin, Youtube, ChevronRight } from "lucide-react";
import logo from "../images/ctv_logo.png";
import HeroBg from "../images/hero-bg.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative w-full overflow-hidden bg-[#f6f5ea]">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HeroBg}
          alt="bg"
          className="w-full h-full object-cover rotate-180 opacity-[0.03]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-[#f6f5ea] to-[#f6f5ea]" />

        {/* Subtle gradient orbs */}
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-gradient-to-r from-[#ff6968]/5 via-[#ff6968]/5 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-r from-[#ff6968]/5 via-[#ff6968]/5 to-transparent rounded-full blur-3xl" />
      </div>

      {/* Top gradient line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#ff6968] to-transparent" />

      {/* ===== Content ===== */}
      <div className="relative z-10 px-6 py-12 lg:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
            {/* LEFT - Brand */}
            <div className="lg:col-span-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="relative">
                  <img src={logo} className="h-11 w-11 rounded-lg rotate-180 object-cover" alt="logo" />
                </div>
                <span className="text-xl font-bold text-[#27271f]">SocialTV</span>
              </div>

              <p className="text-[#3b3b3b] text-sm leading-relaxed mb-6 max-w-sm">
                Transform your social media posts into stunning 4K TV ads.
                The simplest way to reach audiences on connected TV.
              </p>

              {/* Social Icons */}
              <div className="flex gap-3">
                {[
                  { Icon: Twitter, name: "Twitter", color: "#1DA1F2", link: "https://x.com/jambojar" },
                  { Icon: Linkedin, name: "LinkedIn", color: "#0A66C2", link: "https://www.linkedin.com/company/jambojar/about/" },
                  { Icon: Youtube, name: "YouTube", color: "#FF0000", link: "https://www.linkedin.com/company/jambojar/about/" },
                  { Icon: Instagram, name: "Instagram", color: "#E4405F", link: "https://instagram.com" },
                ].map(({ Icon, name, color, link }, i) => (
                  <a
                    key={i}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm border border-[#ff69681a] flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-lg hover:border-[#ff6968]"
                    style={{
                      color: '#3b3b3b',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = color;
                      e.currentTarget.style.color = 'white';
                      e.currentTarget.style.borderColor = color;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '';
                      e.currentTarget.style.color = '';
                      e.currentTarget.style.borderColor = '';
                    }}
                  >
                    <Icon size={16} className="transition-colors duration-300" />
                  </a>
                ))}
              </div>
            </div>

            {/* RIGHT - Links */}
            <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:gap-12">
              {[
                {
                  title: "Company",
                  links: [
                    { name: "Home", path: "/" },
                    { name: "About Us", path: "/about" },
                    // { name: "Careers", path: "/careers" },
                  ]
                },
                {
                  title: "Resources",
                  links: [
                    { name: "Support", path: "/support" },
                    { name: "Contact Us", path: "/contact" },
                    // { name: "Blog", path: "/blog" },
                  ]
                },
                {
                  title: "Legal",
                  links: [
                    { name: "Privacy Policy", path: "/privacy" },
                    { name: "Terms of Service", path: "/terms" },
                    // { name: "Cookie Policy", path: "/cookies" },
                  ]
                },
              ].map((section, idx) => (
                <div key={idx}>
                  <h4 className="text-xs font-semibold text-[#3b3b3b] uppercase tracking-wider mb-4 relative inline-block">
                    {section.title}
                    <span className="absolute -bottom-1.5 left-0 w-1/2 h-0.5 bg-[#ff6968] rounded-full" />
                  </h4>

                  <ul className="space-y-2.5">
                    {section.links.map((link, i ) => (
                      <li key={i}>
                        <Link
                          to={link.path}
                          className="group flex items-center gap-2 text-[#3b3b3b] text-sm hover:text-[#ff6968] transition-all duration-300"
                        >
                          <ChevronRight
                            size={12}
                            className="text-[#ff6968] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                          />
                          <span className="group-hover:translate-x-1 transition-all duration-300">
                            {link.name}
                          </span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Divider */}
          <div className="relative my-8">
            <div className="h-px w-full bg-gradient-to-r from-transparent via-[#ff6968]/30 to-transparent" />
            <div className="absolute left-1/2 -translate-x-1/2 -top-2 w-4 h-4 bg-[#ff6968] rounded-full opacity-20" />
          </div>

          {/* Bottom Bar */}
          <div className="flex items-center justify-center gap-4">
            <p className="text-[#3b3b3b] text-sm">
              © {currentYear} SocialTV. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;